import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from '../../../Components/DateRangeSelector/DateRangeSelector';

export class RecordingsDateRangeSelector extends Component {
  static propTypes = {
    uniqueId: PropTypes.string.isRequired,
    isBig: PropTypes.bool.isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    reduced_recordings: PropTypes.object,
    getRecordings: PropTypes.func
  };

  render() {
    const { uniqueId, isBig, reduced_recordings, getRecordings, mixpanelData } = this.props;
    const { filter, fetching } = reduced_recordings;
    return (
      <DateRangeSelector
        uniqueId={uniqueId}
        isBig={isBig}
        onApply={(startDate, endDate) => getRecordings(startDate, endDate)}
        fromDateTime={filter.fromTime}
        toDateTime={filter.toTime}
        defaultFromDateTime={filter.defaultFromDate}
        defaultToDateTime={filter.defaultToDate}
        disabled={fetching}
        mixpanelData={mixpanelData}
      />
    );
  }
}

export default RecordingsDateRangeSelector;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Recordings/Filters/RecordingsDateRangeSelector.js